import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default from 'react';
import styled from 'styled-components';
import Text from '../text/text.component.js';
import '../media/Img.js';
import { Icon as Icon$1 } from '../media/Icon.js';
import '../../App.css.js';
import { textColorText } from '../../theme/text-theme.js';
var _excluded = ["style", "width", "height", "icon", "titleText", "descriptionText", "isMobile", "titleClassname", "descriptionClassname"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var Div = styled.div.withConfig({
  displayName: "block-mainteinancecomponent__Div",
  componentId: "sc-1ib5ouv-0"
})(["padding-top:96px;display:flex;flex-direction:column;align-items:center;@media screen and (max-width:768px){padding-top:48px;}"]);
var Icon = styled(Icon$1).withConfig({
  displayName: "block-mainteinancecomponent__Icon",
  componentId: "sc-1ib5ouv-1"
})(["", ""], textColorText);
var BlockDescription = function BlockDescription(_ref) {
  var style = _ref.style,
    width = _ref.width,
    height = _ref.height,
    icon = _ref.icon,
    titleText = _ref.titleText,
    descriptionText = _ref.descriptionText;
  _ref.isMobile;
  _ref.titleClassname;
  _ref.descriptionClassname;
  _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Div, {
    style: _objectSpread({
      width: width,
      height: height
    }, style)
  }, /*#__PURE__*/React__default.createElement(Icon, {
    color: "default",
    icon: icon,
    fontSize: "48px"
  }), /*#__PURE__*/React__default.createElement(Text, {
    color: "grey-1",
    fontFamily: "euclid",
    type: "label",
    fontSize: "medium",
    tag: "p",
    style: {
      textAlign: "center",
      marginTop: "16px"
    }
  }, titleText), /*#__PURE__*/React__default.createElement(Text, {
    fontFamily: "euclid",
    type: "paragraph",
    fontSize: "small",
    color: "grey-1",
    style: {
      textAlign: "center",
      marginTop: "8px"
    }
  }, descriptionText));
};
export { BlockDescription as default };